import React, { useEffect, useRef, useState } from 'react';

import DOMPurify from 'dompurify';

import { Log } from 'helpers/errorLogger';







export interface Props {

  markdown: string;

  className?: string;

  onCollectionLinkClick?: () => void; // Add a prop for the click handler

}




const Markdown: React.FC<Props> = ({ markdown, className, onCollectionLinkClick }) => {

  const [safeMarkdown, setSafeMarkdown] = useState('');

  const containerRef = useRef<HTMLDivElement | null>(null);




  useEffect(() => {

    if (typeof markdown === 'string') {

      setSafeMarkdown(DOMPurify.sanitize(markdown, { ADD_ATTR: ['target'] }));

    }

  }, [markdown]);




  useEffect(() => {

    if (containerRef.current) {

      const links = containerRef.current.querySelectorAll('a');

      links.forEach(link => {

        if (link.href.includes('#collection')) {

          link.addEventListener('click', (event) => {

            event.preventDefault(); // Prevent the default link behavior

            if (onCollectionLinkClick) {

              onCollectionLinkClick(); // Call the provided click handler

            }

          });

        }

      });

    }

  }, [safeMarkdown, onCollectionLinkClick]);




  if (typeof markdown !== 'string') {

    Log.error(new Error(`Markdown: Invalid markdown property. Expected string but received ${typeof markdown}`));


    return <></>;

  }




  return <div ref={containerRef} dangerouslySetInnerHTML={{ __html: safeMarkdown }} className={className}></div>;

};




export default Markdown;